import {
  BENEFIT_HISTORY_LOADING,
  BENEFIT_HISTORY_SUCCESS,
  BENEFIT_HISTORY_FAILED
} from '../actions/benefitHistoryActions'
const BenefitHistory = (state = {}, action) => {
  switch (action.type) {
    case BENEFIT_HISTORY_LOADING:
      return Object.assign({}, state, {
        isLoading: true
      })
    case BENEFIT_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        benefitHistory: action.response,
        error: null,
        isLoading: false
      })
    case BENEFIT_HISTORY_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isLoading: false
      })
    default:
      return state
  }
}
export default BenefitHistory



// WEBPACK FOOTER //
// ./src/redux/reducers/benefitHistoryReducer.js